import CustomModalWrapper from 'components/CustomModalWrapper/CustomModalWrapper';
import DetailTable from 'components/DetailTable';
import { ConfigItem } from 'components/DetailTable/types';
import LoadingScreen from 'components/LoadingScreen';
import { useAtomValue } from 'jotai';
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import { companyIdAtom } from 'views/state';

import { fetchReportDetail } from './helper';

interface Props {
  id: number;
}

const ReportDetailModal = ({ id }: Props) => {
  const [data, setData] = useState(null);
  const companyId = useAtomValue(companyIdAtom);

  useEffect(() => {
    fetchReportDetail(id, companyId)
      .then((res) => {
        if (res) {
          setData(res);
        }
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const reportDetailConfig: ConfigItem[] = [
    { name: 'ID', key: 'id', type: 'number' },
    { name: 'Name', key: 'name', type: 'string' },
    { name: 'Report Format', key: 'report_format', type: 'string' },
    { name: 'Report ID', key: 'report_id', type: 'string' },
    { name: 'Report Creation Date', key: 'report_creation_date', type: 'date' },
    { name: 'Last Download Date', key: 'last_download_date', type: 'date' },
    { name: 'Report Status', key: 'report_status', type: 'string' },
    { name: 'Report Type', key: 'report_type', type: 'string' },
    { name: 'Report Size', key: 'report_size', type: 'string' },
    { name: 'Details Fetched', key: 'details_fetched', type: 'boolean' },
    { name: 'Report Downloaded', key: 'report_downloaded', type: 'boolean' },
  ];

  if (!data) return <LoadingScreen />;

  return (
    <CustomModalWrapper id="report-detail-modal">
      <Row>
        <Col>
          <DetailTable data={data} config={reportDetailConfig} />
        </Col>
      </Row>
    </CustomModalWrapper>
  );
};

export default ReportDetailModal;
